export const E_TypesReports = {
  simpleDoubleTrack: 'reportSimplesDuasVias',
  simple: 'reportVendaOrcamento',
  cupom58mm: 'reportCoupon58mm',
  contrato: 'reportContrato',
}
